import api from './api';

const getCategories = async (params = {}) => {
    const response = await api.get('/gov-exam-categories', { params });
    return response.data;
};

const getCategoryById = async (id) => {
    const response = await api.get(`/gov-exam-categories/${id}`);
    return response.data;
};

// Public — published tests under one category, no auth required.
const getTestsByCategory = async (govExamCategoryId) => {
    const response = await api.get(`/mocktest/category/${govExamCategoryId}`);
    return response.data.tests || [];
};

// Gated — caller must handle a 403 (requiresPurchase) from the response.
// On 403 the body carries govExamCategoryId (see mockQuiz.js) — Mock
// per-folder Buy Now, so the caller redirects to /mock-checkout/:categoryId,
// which fetches the category's own title/price itself (mirrors BoardQuiz.jsx).
const getMockTestQuestions = async (mockTestId) => {
    const response = await api.get(`/mock-quiz/test/${mockTestId}`);
    return response.data;
};

// Per-test order — kept for backward compat, no longer used by the browse/
// checkout flow (Mock per-folder Buy Now moved purchase to the category
// level, see the category-scoped functions below). Cutover decision:
// left in place rather than removed.
const createMockOrder = async (mockTestId, couponCode) => {
    const response = await api.post('/mock-orders/create-order', { mockTestId, couponCode });
    return response.data;
};

const verifyMockOrder = async (payload) => {
    const response = await api.post('/mock-orders/verify', payload);
    return response.data;
};

// Category-scoped ("folder") order — mirrors boardService.js's
// createBoardOrder/verifyBoardOrder exactly, against a GovExamCategory
// instead of a BoardCategory.
const createMockCategoryOrder = async (govExamCategoryId, couponCode) => {
    const response = await api.post('/mock-orders/category/create-order', { govExamCategoryId, couponCode });
    return response.data;
};

const verifyMockCategoryOrder = async (payload) => {
    const response = await api.post('/mock-orders/category/verify', payload);
    return response.data;
};

const submitMockQuiz = async (payload) => {
    const response = await api.post('/mock-quiz/submit', payload);
    return response.data;
};

// Public — no purchase/login required to view rankings.
const getMockLeaderboard = async (mockTestId) => {
    const response = await api.get(`/mock-quiz/leaderboard/${mockTestId}`);
    return response.data;
};

const mockTestService = {
    getCategories,
    getCategoryById,
    getTestsByCategory,
    getMockTestQuestions,
    createMockOrder,
    verifyMockOrder,
    createMockCategoryOrder,
    verifyMockCategoryOrder,
    submitMockQuiz,
    getMockLeaderboard
};

export default mockTestService;
